import { MAIN_PLAYER_TOGGLE, NOTIFICATION, SIDEBAR_OPEN, VOLUME_TOGGLE } from "../types/styles";

const initialState = {
  sidebarOpen: false,
  mainPlayerOpen: false,
  volumeOpen: false,
  notification: { active: "unset", loading: true, error: false, message: "" },
};

const stylesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SIDEBAR_OPEN:
      return { ...state, sidebarOpen: payload };
    case MAIN_PLAYER_TOGGLE:
      return { ...state, mainPlayerOpen: payload };
    case VOLUME_TOGGLE:
      return { ...state, volumeOpen: payload };
    case NOTIFICATION:
      return { ...state, notification: payload };
    default:
      return state;
  }
};

export default stylesReducer;
